import { Box } from '@mui/material'
import { useMemo } from 'react'
import { SliderProps } from './Slider3'
import { StyledTypography } from './styles'

const SliderFootNote = ({
  footnote,
  footnotePosition,
  disabled,
}: Pick<SliderProps, 'footnote' | 'footnotePosition' | 'disabled'>) => {
  const justifyContent = useMemo(() => {
    if (footnotePosition === 'center') return 'center'
    if (footnotePosition === 'left') return 'start'
    return 'end'
  }, [footnotePosition])

  if (!footnote) return null
  return (
    <Box display="flex" width="100%" justifyContent={justifyContent}>
      <StyledTypography disabled={disabled}>{footnote}</StyledTypography>
    </Box>
  )
}

export default SliderFootNote
